import styled from 'styled-components'

export const Row = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
  padding: ${props => props.theme.spacing.sp8} 0;
  border: none;
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  background-color: transparent;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.overlay.hover};
  }
`

export const ErrorCount = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Count = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
